(() => {
  let minDesktopMenuWidth = 842;
  let menuMobile = false;

  const menuItems = document.querySelectorAll('#mega-menu > li');
  const el = document.querySelector('.container-fluid');

  const headerActions = document.querySelector('#mega-menu > li'); // first element with header actions
  const megaMenu = document.getElementById('mega-menu');

  if (!megaMenu) return;

  const hamburger = document.querySelector(
      `button[data-bs-target="#mega-menu-collapse"]`
  ).parentNode;
  const navContainer = document.querySelector('#mega-menu-collapse .nav-container');

  const getAvailableWidth = () => {
    const computedNav = getComputedStyle(el);
    return (
        el.clientWidth - (parseFloat(computedNav.paddingLeft) + parseFloat(computedNav.paddingRight))
    );
  };

  const getMenuWidth = () => {
    let result = 0;
    menuItems.forEach((item, key) => {
      if (key !== 0) {
        result += item.clientWidth;
      }
    });
    return result;
  };

  const shouldEnableMobile = () => {
    /* 8517-bug-navigation
    const menuWidth = getMenuWidth();
    const availableWidth = getAvailableWidth();

    if (menuWidth > 0 && availableWidth > 0) {
      if (menuWidth < minDesktopMenuWidth) {
        minDesktopMenuWidth = menuWidth;
      }
    }
    return minDesktopMenuWidth - availableWidth > 5; // -5 added to compensate for 2-3px difference in width when using flex-grow */
    return window.innerWidth < minDesktopMenuWidth;
  };

  const viewHandler = {
    setDesktop: () => {
      headerActions.classList.remove('d-flex');
      headerActions.classList.add('d-none');

      hamburger.classList.remove('d-flex');
      hamburger.classList.add('d-none');

      megaMenu.classList.remove('flex-column', 'd-none');
      megaMenu.classList.add('flex-row', 'd-flex');

      navContainer.classList.remove('mobile-view');
    },
    setMobile: () => {
      headerActions.classList.remove('d-md-none', 'd-none');
      headerActions.classList.add('d-flex');

      hamburger.classList.remove('d-md-none', 'd-none');
      hamburger.classList.add('d-flex');

      megaMenu.classList.remove('flex-row', 'flex-md-row', 'd-none');
      megaMenu.classList.add('d-flex');
      megaMenu.classList.add('flex-column');

      navContainer.classList.add('mobile-view');
    },
  };

  hamburger.addEventListener('click', e => {
    // console.log('hamburger click');
    setTimeout(() => {
      if (document.querySelector('button[data-bs-target="#mega-menu-collapse"]').classList.contains('collapsed')) {
        document.body.style.overflowY = 'auto';
      } else {
        document.body.style.overflowY = 'hidden';
      }
    }, 100);
  });

  const handleChange = (isMobile) => {
    if (isMobile) {
      viewHandler.setMobile();
      return;
    }
    viewHandler.setDesktop();
  };

  const checkIfMenuShouldEnable = () => {
    menuMobile = shouldEnableMobile();
    handleChange(menuMobile);
    return menuMobile;
  };

  // init checking if mobile menu should be active
  // timeout added to calculate the width of the element
  setTimeout(checkIfMenuShouldEnable, 20);

  let timer = null;
  window.addEventListener('resize', () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => checkIfMenuShouldEnable, 20);
  });

  (() => {
    const menuWrapper = document.getElementById('mega-menu-collapse');
    const menuButton = document.querySelector(`[data-bs-target="#mega-menu-collapse"]`);
    const mega = document.getElementById('mega-menu');
    const megaButtons = document.querySelectorAll('nav.mega-menu .btn');

    const deactivateColorOnMainButtons = () => {
      // megaButtons.forEach(active => active.classList.remove('text-brand-red'));
    }


    // megaButtons.forEach(el => {
    //   el.addEventListener('mouseenter', (e) => {
    //     // deactivateColorOnMainButtons();
    //     // e.currentTarget.classList.add('text-brand-red');
    //   })
    // });

    $("a.link-button").mouseover(function () {
      $('.btn.btn-black').addClass('collapsed');
    });

    megaButtons.forEach(el => el.addEventListener('mouseleave', e => {
      // console.log('mouseleave event');
      // if ($('a.link-button:hover').length > 0) {
      //     $('.btn.btn-black').addClass('collapsed');
      // }
    }))

    const activateMobileMenu = () => {
      menuWrapper.classList.remove('show');
      menuWrapper.closest('li')?.querySelector('.megamenu-with-child-item')?.classList.remove('active');
      menuButton.classList.add('collapsed');
      mega.classList.add('mega-menu-mobile');
    };

    const deactivateMobileMenu = () => {
      menuWrapper.classList.add('show');
      menuButton.classList.remove('collapsed');
      mega.classList.remove('mega-menu-mobile');
      document.body.style.overflowY = 'auto';
    };

    const handleResize = () => {
      if (checkIfMenuShouldEnable()) {
        activateMobileMenu();
        return;
      }
      deactivateMobileMenu();
    };

    // init checking if mobile menu should be active
    // timeout added to calculate the width of the element
    setTimeout(handleResize, 20);

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 10);
    });

    const closeActiveMenuElements = () => {
      const button = document.querySelector(
          '.mega-menu .mega-menu-item > .btn[aria-expanded="true"]'
      );
      if (button) {
        button.setAttribute('aria-expanded', false);
        button.classList.add('collapsed');
      }

      const menu = document.querySelector('.mega-menu-children.collapse.show');
      if (menu) {
        menu.setAttribute('aria-expanded', false);
        menu.classList.remove('show');
        menu.closest('li')?.querySelector('.megamenu-with-child-item')?.classList.remove('active');
      }

      const children = mega.querySelectorAll(`.fade-in`);
      children.forEach(child => child.classList.remove('fade-in'));
    };



    document.querySelectorAll('#mega-menu .mega-menu-item').forEach(el => el.addEventListener('mouseenter', e => {
      const children = el.querySelector('.mega-menu-children');

      // console.log(window.innerWidth);

      const megaLeft = mega.getBoundingClientRect().x;
      const megaRight = mega.getBoundingClientRect().x + mega.getBoundingClientRect().width;

      const halfWindow = window.innerWidth / 1.8;

      const elBounding = el.getBoundingClientRect();

      if (children) {

        if ((elBounding.x + elBounding.width / 2) < halfWindow) {
          children.style.left = 0;

          const width = megaRight - elBounding.x;

          children.style.width = `${width < 1000 ? width : 1000}px`;
        } else {
          children.style.right = 0;

          const width = megaLeft + elBounding.x + elBounding.width;

          children.style.width = `${width < 1000 ? width : 1000}px`;
        }

      }



      // console.log(el.getBoundingClientRect());

    }))

    const linkButtonMain = document.querySelectorAll('#mega-menu .mega-menu-item > a.btn');
    linkButtonMain.forEach(el => el.addEventListener('mouseenter', () => {
      closeActiveMenuElements();
    }));

    const closeActiveMenuButtons = () => megaButtons.forEach(button => {
      button.classList.add('collapsed');
    });

    // listens to clicks outside active mega menu.
    window.addEventListener('click', (e) => {
      let shouldHide = true;
      // console.log(e.target.classList.contains('btn'));
      if (shouldHide) {
        e.target.querySelector('.btn .megamenu-with-child-item')?.classList.remove('active');
      }


      if (!e.path || e.path.length < 1) return;

      e.path.forEach((node) => {
        if (!node.classList) return;
        if (!node.classList.contains('mega-menu-collapse')) return;
        shouldHide = false;

      });

      if (shouldHide) closeActiveMenuElements();
    });

    document.addEventListener('keydown', (e) => e.code === 'Escape' && closeActiveMenuElements());

    const closeActiveMenu = () => {
      closeActiveMenuButtons();
      closeActiveMenuElements();
      handleCloseActiveNavItems();
    };
    mega.addEventListener('mouseleave', () => {
      deactivateColorOnMainButtons();
      if (window.innerWidth >= minDesktopMenuWidth) {
        closeActiveMenu();
      }
    });

    const searchWrapper = document.querySelector('.search-wrapper');

    const openMenu = (e) => {
      if (searchWrapper
          && ((searchWrapper.style.display !== 'none' && searchWrapper.style.display !== '')
              || searchWrapper.classList.contains('active'))) { // checks if search results are active
        return;
      }

      if (window.innerWidth >= minDesktopMenuWidth) {
        closeActiveMenu();

        e.target.classList.remove('collapsed');

        const child = document.querySelector(e.target.dataset.bsTarget);

        if(child){
          child.classList.add('show');
          child.closest('li')?.querySelector('.megamenu-with-child-item')?.classList.add('active');
        }

        const children = mega.querySelectorAll(`${e.target.dataset.bsTarget} > div`);

        if(!children || children.length){
          return;
        }

        setTimeout(() => {
          children.forEach(child => child.classList.add('fade-in'));
        }, 10);
      }
    };

    const buttons = document.querySelectorAll('#mega-menu .nav-title');
    // buttons.forEach(btn => btn.addEventListener('mouseenter', e => {
    //   console.log("mouse enter");
    // }));

    let activeWrapper = null;

    const handleMouseEnter = (e) => {
      const activeChildren = document.querySelector('.mega-menu-children.collapse.show');
      activeWrapper = activeChildren.querySelector('.mega-menu-children-active');

      activeWrapper.innerHTML = null;

      const navItems = e.currentTarget.nextElementSibling && e.currentTarget.nextElementSibling.cloneNode(true);

      buttons.forEach(el => el.classList.remove('text-brand-red'));
      if (navItems) e.currentTarget.classList.add('text-brand-red');

      (!shouldEnableMobile() && navItems) && activeWrapper.appendChild(navItems);
    }

    const handleCloseActiveNavItems = (e) => {
      const activeWrappers = document.querySelectorAll('.mega-menu-children-active');
      activeWrappers && activeWrappers.forEach(el => el.innerHTML = null);
    }

    megaButtons.forEach(button => button.addEventListener('mouseenter', openMenu));
  })();
})();

// scrolling to activated element
(function () {
  let minDesktopMenuWidth = 842;
  const mega = document.getElementById('mega-menu');
  if (!mega) return;

  const buttons = mega.querySelectorAll('.btn[data-bs-toggle="collapse"]');

  const handleClick = (e) => {
    if (!mega.classList.contains('mega-menu-mobile')) return;
    if (window.innerWidth > minDesktopMenuWidth) {
      setTimeout(() => {
        mega.scroll({
          top: e.target.offsetTop,
          behavior: 'smooth',
        });
      }, 350);
    }

  };

  buttons.forEach((button) => button.addEventListener('click', (e) => {
    // console.log('accordion click');
    handleClick(e)
  }));
})();

$(document).ready(() => {
  const mega = $('#mega-menu');
  $(mega).addClass('init-finished');

  $(".img-fluid[data-onclick='']").removeAttr('data-onclick');
  $(".img-fluid[data-onclick]").attr('style','cursor: pointer');
  $(".img-fluid[data-onclick]").on('click', function () {
    let href = $(this).data('onclick');
    if(href) {
      window.location.href = href
      return false;
    }

  });

  document.querySelectorAll('.megamenu-with-child-item').forEach(function(link) {
    link.addEventListener('click', function(event) {
      window.location.href = link.href;
    });
  });
});
